import React, { Component } from "react";
import Iovation from "../../iovation/Iovation";
import { withValidation } from "../hocs/WithValidation";
import {
  withValidationOutputPropTypes,
  sharedFormInputPropTypes,
} from "../hocs/prop-types";

class DeviceFingerprint extends Component {
  constructor(props) {
    super(props);
    this.name = "deviceFingerprint";
  }

  componentDidMount() {
    this.props.context.registerFormElement({
      value: this.value,
      name: this.name,
      valid: Boolean(this.value)
    });
  }

  componentWillUnmount() {
    this.props.context.deregisterFormElement({
      name: this.props.name,
    }, this);
  }

  handleChange(value) {
    const { handleChange, context } = this.props;
    this.value = value;
    const event = {
      target: {
        value,
        name: this.name
      },
      type: "blur"
    };
    handleChange(event, context);
    this.props.context.updateFormElement({
      value: this.value,
      name: this.name,
      valid: Boolean(this.value)
    });
  }
  render() {
    return <Iovation onReceiveResults={value => this.handleChange(value)} />;
  }
}

DeviceFingerprint.propTypes = {
  ...withValidationOutputPropTypes,
  ...sharedFormInputPropTypes
};

export default withValidation(DeviceFingerprint);
